import type { ReactNode } from 'react';

import { SYSTEM_LOGS_CACHE_DURATION_MINUTES } from '@/system-logs/constants/system-logs-cache-duration';
import { label } from '@/utils/format/label';

import { Table } from '../../entities/system-logs';

import { RefreshCacheButton } from './refresh-cache-button';
import { SystemLogsExportButton } from './system-logs-export-button';

export type SystemLogsResultsBarProps = {
  total: number;
  table?: Table;
  leftExtra?: ReactNode;
};

export function SystemLogsResultsBar({
  total,
  table,
  leftExtra,
}: SystemLogsResultsBarProps) {
  return (
    <div className="flex items-center justify-between px-6 py-1">
      <div className="flex items-center gap-3 text-sm text-gray-600">
        <div className="flex items-center gap-3">
          <div
            data-testid="system-logs-results-count"
            className="text-sm font-medium"
          >
            {total.toLocaleString()} {label(['result', 'results'], total)}
          </div>
          <span className="text-sm text-muted-foreground/75">•</span>
          <div className="flex items-center gap-1">
            <span className="text-sm text-muted-foreground/75">
              Updates every {SYSTEM_LOGS_CACHE_DURATION_MINUTES} minutes
            </span>
            <RefreshCacheButton />
          </div>
        </div>
        {leftExtra}
      </div>
      <div className="flex items-center gap-2">
        <SystemLogsExportButton table={table} />
      </div>
    </div>
  );
}
